export default __webpack_public_path__ + "static/media/Idea_concept.25cfcc72.png";